import { render, staticRenderFns } from "./AddFund.vue?vue&type=template&id=b229a932"
import script from "./AddFund.vue?vue&type=script&lang=js"
export * from "./AddFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports